const PADDING = 32;
const ANIMATION_SPEED = 300;
const updateSelectedButton = (activeButton, selectedButton) => {
  activeButton & activeButton.classList.remove('active');
  selectedButton && selectedButton.classList.add('active');
};

const setParentHeight = (el, height) => {
  el.style.height = `${height}px`;
};

const showElement = (el) => {
  el.style.display = 'block';
  el.classList.add('is-visible');
};

const hideElement = (el) => {
  el.style.display = 'none';
  setTimeout(() => el.classList.remove('is-visible'), 10);
};

const showTabGroup = (button, target) => {
  let containerHeight = 0;
  const selectors = {
    $group: document.querySelectorAll('div.is-visible[data-faqs-group]'),
    $targetedGroup: document.querySelectorAll(`[data-faqs-group="${target}"]`),
    $parent: document.querySelector('[data-faqs-list]'),
    $activeButton: document.querySelector('.faqs-block__tab-toggle.active'),
  };

  if (button) {
    updateSelectedButton(selectors.$activeButton, button);
  }

  selectors.$group.forEach((el) => hideElement(el));
  selectors.$targetedGroup.forEach((el) => {
    showElement(el);
    containerHeight += el.offsetHeight;
  });

  setTimeout(
    () => setParentHeight(selectors.$parent, containerHeight),
    ANIMATION_SPEED
  );
};

const resizeParentContainer = () => {
  let newHeight = 0;
  const selectors = {
    $parent: document.querySelector('[data-faqs-list]'),
    $children: document.querySelectorAll('.accordion__container'),
  };
  selectors.$children.forEach((el) => (newHeight += el.offsetHeight));
  newHeight += PADDING;
  setParentHeight(selectors.$parent, newHeight);
};

const initFaqsBlock = () => {
  const buttons = document.querySelectorAll('[data-target-faqs-group]');
  const accordionItem = document.querySelectorAll('.accordion__item');

  buttons.forEach((btn) =>
    btn.addEventListener('click', () => {
      showTabGroup(btn, btn.dataset.targetFaqsGroup);
    })
  );

  accordionItem.forEach((item) =>
    item.addEventListener('click', () => {
      setTimeout(() => resizeParentContainer(), ANIMATION_SPEED);
    })
  );
};

export default () => {
  const enableFAQsModule = document.querySelector('.js-enable-faq-tabs');
  if (!enableFAQsModule) {
    return false;
  }
  document.addEventListener('DOMContentLoaded', initFaqsBlock);
};
